<template>
    <div class="card">
        <div class="list" v-loading="taskData.loading.list">
            <el-row class="list-control">
                <el-col :span="24">{{
                    new Date().getFullYear() +
                    '年' +
                    (new Date().getMonth() + 1) +
                    '月' +
                    new Date().getDate() +
                    '日'
                }}</el-col>
            </el-row>
            <div class="list-table">
                <el-table :data="taskData.list" stripe style="width: 100%">
                    <el-table-column label="客户" width="360">
                        <template slot-scope="scope">
                            <el-link
                                type="primary"
                                :underline="false"
                                @click="DetailCustomer(scope.row)"
                                >{{ scope.row.name }}</el-link
                            >
                        </template>
                    </el-table-column>
                    <el-table-column prop="visit_remind_memo" label="任务内容"></el-table-column>
                    <el-table-column
                        prop="visit_remind_at"
                        label="任务时间"
                        width="240"
                    ></el-table-column>
                    <el-table-column width="80">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="StateTask(scope.row)">完成</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="list-pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next, sizes"
                    :current-page.sync="taskData.pages.page"
                    :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                    :page-size="taskData.pages.pagesize"
                    :total="taskData.pages.total"
                    @size-change="GetSize"
                    @current-change="GetCurrent"
                ></el-pagination>
            </div>
        </div>

        <v-CustomerDetail
            :detailParam="componentParam.customerDetail"
            v-if="componentParam.customerDetail.visible"
        />
    </div>
</template>

<script>
import CustomerDetail from '@/components/customer/Detail'
export default {
    components: {
        'v-CustomerDetail': CustomerDetail
    },
    inject: ['reload'],
    data() {
        return {
            searchData: {
                order_field: 'visit_remind_at',
                order: 'desc'
            },
            taskData: {
                loading: {
                    list: []
                },
                list: [],
                pages: {
                    page: 1,
                    pagesize: 100,
                    total: 0
                }
            },
            componentParam: {
                customerDetail: {}
            }
        }
    },
    created() {
        this.$nextTick(() => {})
    },
    mounted() {
        this.$nextTick(() => {
            this.GetFollow()
        })
    },
    methods: {
        // 订单列表
        GetFollow() {
            this.taskData.loading.list = true
            this.$request({
                url: '/api/v1/getremindlist',
                params: {
                    ...this.searchData,
                    ...this.taskData.pages
                }
            }).then(res => {
                if (!res.status) {
                    this.taskData.loading.list = false
                    this.taskData.list = res.data.list
                    this.taskData.pages.total = parseInt(res.data.total)
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        GetSize(val) {
            this.taskData.pages.pagesize = val
            this.GetOrder()
        },
        GetCurrent(val) {
            this.taskData.pages.page = val
            this.GetOrder()
        },
        // 完成任务
        StateTask(row) {
            this.$confirm('确认该任务已经完成, 是否继续?', '警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$request({
                        url: '/api/v1/customer_follow_add',
                        params: {
                            customer_id: row.customer_id,
                            visit_id: row.id,
                            communicate_record: row.visit_remind_memo
                        }
                    }).then(res => {
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            this.GetFollow()
                        }
                    })
                })
                .catch(() => {})
        },
        // 客户详情
        DetailCustomer(row) {
            if (row.customer_id) {
                this.componentParam.customerDetail = {
                    visible: true,
                    row: {
                        customer_id: row.customer_id
                    }
                }
            }
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/common.less';
@import '~@/assets/css/list.less';
</style>
